export default __webpack_public_path__ + "static/change_country-f2979cbc8a243fbfc48a8822d83f9d92.png";